module.exports = __webpack_public_path__ + "static/media/2019hrishi.70b2d244.jpeg";